import 'virtual:uno.css'
import './assets/css/index.css'

import { createApp, markRaw } from 'vue'
import { createPinia } from 'pinia'
import VueFeather from 'vue-feather'
import PageHeaderVue from './components/ui/PageHeader.vue'
import Icon from '@/components/ui/Icon.vue'
import vue3GoogleLogin from 'vue3-google-login'
import i18n from './i18n'

import App from './App.vue'
import router from './router'

const app = createApp(App)
const pinia = createPinia()

pinia.use(({ store }) => {
  store.router = markRaw(router)
})

app.component(VueFeather.name as string, VueFeather)
app.component('PageHeader', PageHeaderVue)
// eslint-disable-next-line vue/multi-word-component-names
app.component('Icon', Icon)
app.use(pinia)
app.use(router)
app.use(i18n)
app.use(vue3GoogleLogin, {
  clientId: import.meta.env.VITE_GOOGLE_CLIENT_ID || '',
})

app.mount('#app')
